import { Form, Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import { TextField } from '../../../Components/Formik/BaseTextField';

export const PasswordModal = ({ onPasswordSubmit, validPassword, partial = false }) => {
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const formikProps = {
    initialValues: {
      password: '',
    },
    validationSchema: Yup.object().shape({
      password: Yup.string(),
    }),
    onSubmit: (values) => onPasswordSubmit(values.password),
  };
  return (
    <Formik {...formikProps} className="password-modal-container">
      {({ handleChange, handleBlur, isSubmitting }) => (
        <Form className={`password-modal-form ${partial ? 'password-modal-partial' : 'password-modal-inline'}`}>
          <div className="password-modal-main">
            <div className="password-modal-title">
              {partial ? 'Parts of this service require a password to view' : 'This service requires a password to view'}
            </div>
            <TextField placeholder="password..." name="password" type="password" onChange={handleChange} onBlur={handleBlur} />
            {!validPassword && hasSubmitted && !isSubmitting && <div className="bad-password">Sorry that password is incorrect.</div>}
          </div>

          <div className="password-modal-footer">
            <button className="accent-button" type="submit" onClick={() => setHasSubmitted(true)}>
              {partial ? 'Unlock full service' : 'Submit'}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};
